import { margin, padding } from '..';
const modals = {
    dialogPadding: padding.all('none'),
    dialogPaddingMobile: padding.all('none'),
    borderRadius: '0',
    iconSize: '6rem',
    iconSizeMobile: '4.5rem',
    iconMargin: margin.all('none', 'none', 'small', 'none'),
    iconMarginMobile: margin.all('none', 'none', 'large', 'none'),
    titlePadding: padding.right('larger'),
    titlePaddingMobile: padding.right('large'),
    subtitlePadding: padding.bottom('normal'),
    subtitlePaddingMobile: padding.bottom('normal'),
    headingPadding: padding.all('none'),
    headingBorderBottom: '0',
    headingBorderBottomColor: 'transparent',
    buttonsPadding: padding.top('large'),
    buttonsPaddingMobile: padding.all('normal'),
    footerBorderTop: '0',
    contentPadding: padding.all('none'),
    contentPaddingMobile: padding.all('none'),
    contentBorderTop: '0',
    displayHeader: false,
    overlayOpacity: 0.5,
    useThemeColor: false,
};
export default modals;
//# sourceMappingURL=modals.js.map